import { AuthoringUtils } from '@adobe/aem-spa-page-model-manager'
import React from 'react'
import { useIsSsr } from '../../../utils/isSsr'
import { MapErrorComponentProps } from './MapErrorComponentEditConfig'
import { withErrorBoundary, ErrorFallback } from '../ErrorBoundary'

const MapErrorComponent: React.FC<MapErrorComponentProps> = ({
  cqPath,
  model
}) => {
  const isSsr = useIsSsr()
  const cqType = model?.cqType
  if (isSsr) {
    // eslint-disable-next-line no-console
    console.error(
      `Component Not Mapped. data-cq-type: ${cqType}, data-cq-path: ${cqPath}`
    )
  }

  const propsCqPath = AuthoringUtils.isInEditor()
    ? { 'data-cq-path': cqPath }
    : {}

  return (
    <div
      className="wam-errorcomponent"
      style={{ display: 'none' }}
      {...propsCqPath}
      data-cq-type={cqType}
    >
      Component Not Mapped
    </div>
  )
}

const MapErrorComponentWithErrorBoundary = withErrorBoundary(
  MapErrorComponent,
  {
    componentName: 'MapErrorComponent',
    fallback: <ErrorFallback componentName="MapErrorComponent" />
  }
)

export default MapErrorComponentWithErrorBoundary
